import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetMeetingRoomsInput, MeetingRoomInput, MeetingRoomResult, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class MeetingRoomService {

  constructor(private httpClient: HttpClient) { }

  public addMeetingRoom(meetingRoomInput: MeetingRoomInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'MeetingRoom/AddMeetingRoom', meetingRoomInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editMeetingRoom(id: number, meetingRoomInput: MeetingRoomInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'MeetingRoom/EditMeetingRoom?id=' + id, meetingRoomInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteMeetingRoom(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'MeetingRoom/DeleteMeetingRoom?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getMeetingRooms(getMeetingRoomsInput: GetMeetingRoomsInput, token: string): Promise<ResultList<MeetingRoomResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'MeetingRoom/GetMeetingRooms', getMeetingRoomsInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<MeetingRoomResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<MeetingRoomResult>(), result.error));
  }
}
